import { Comment as CommentType } from '@/types/comment'
import { ReadMoreButton } from '@/components/button/ReadMoreButton'

interface Props {
  comment: CommentType
  needReadMore: boolean
}

export const Comment: React.FC<Props> = ({ comment, needReadMore }) => {
  if (!needReadMore)
    return (
      <div className="pt-2 pb-4 text-sm whitespace-pre-wrap break-words">
        {comment.comment}
      </div>
    )
  return (
    <ReadMoreButton showHeight={85} align="right">
      <div className="pt-2 pb-0 text-sm whitespace-pre-wrap break-words">
        {comment.comment}
      </div>
    </ReadMoreButton>
  )
}
